import store from '@/store'
import changeLog from './changelog'
import { getProjectByUrl } from '@/store/urls'

store.commit('changeLog', changeLog)

let baseImgUrl = 'terryz.gitee.io'
let site = 'gitee'
let lang = 'cn'
// host 和 hostname 的区别在于，hostname不带端口号
if (window.location.hostname === 'terryz.github.io') {
  baseImgUrl = 'terryz.github.io'
  site = 'github'
  lang = 'en'
}

store.commit('baseImgUrl', `https://${baseImgUrl}`)
store.commit('site', site)
store.commit('language', lang)

store.commit('loadLanguage')

const project = getProjectByUrl()
if (project && Object.keys(project).length) {
  store.commit('project', project)
}
